import { supabase } from "@/integrations/supabase/client";

/**
 * Fix a specific book's cover by updating to correct URL and clearing cache
 */
export async function fixBadBookCover(
  bookId: string, 
  correctCoverUrl: string
) {
  try {
    console.log(`[FixCover] Fixing cover for book ${bookId}`);
    
    const { error } = await supabase
      .from('books')
      .update({ 
        cover_url: correctCoverUrl,
        cover_cache_url: null,
        cover_cached: false
      })
      .eq('id', bookId);

    if (error) {
      console.error('[FixCover] Error updating cover:', error);
      throw error;
    }

    console.log('[FixCover] Cover fixed successfully');
    return { success: true };
  } catch (error) {
    console.error('[FixCover] Error in fixBadBookCover:', error);
    throw error;
  }
}

/**
 * Fix the Harry Potter Deathly Hallows cover specifically
 */
export async function fixHarryPotterCover() {
  const bookId = 'b1ddb855-5b7e-4d28-bcac-4c903fe7dc83';
  const correctCoverUrl = 'https://covers.openlibrary.org/b/id/8562110-L.jpg';
  
  return fixBadBookCover(bookId, correctCoverUrl);
}
